const STATUS_MAP = {
    pending: { label: 'در انتظار', className: 'status-pending' },
    approved: { label: 'تأیید شده', className: 'status-approved' },
    paid: { label: 'پرداخت شده', className: 'status-paid' },
    cancelled: { label: 'لغو شده', className: 'status-cancelled' },
};

export default function CommissionStatusBadge({ status }) {
    const meta = STATUS_MAP[status] || { label: status, className: '' };
    return <span className={`status-badge ${meta.className}`}>{meta.label}</span>;
}